import React, { PropsWithChildren } from 'react';

import './layer-tooltip.scss';

type LayerToolipProps = { tip: string; disabled?: boolean; children: PropsWithChildren<any>; id?: string };

const LayerTooltip = ({ tip, children, id = 'tooltip', disabled = false }: LayerToolipProps) => {
  return (
    <div data-html={true} data-tip={tip} data-for={id} data-event={'click focus'} className={`layer-info-icon ${disabled ? 'tooltip-disabled' : ''}`}>
      {children}
    </div>
  );
};

export default LayerTooltip;
